import { render, staticRenderFns } from "./languagevarianthtml.vue?vue&type=template&id=171547bc&scoped=true"
import script from "./languagevarianthtml.vue?vue&type=script&lang=js"
export * from "./languagevarianthtml.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171547bc",
  null
  
)

export default component.exports